export type IAdSpacePosition = 'headerSpace' | 'desktopSide' | 'mobileSpace';

export interface AdSpace {
  id?: number;
  adSpaceName: string;
  positionName?: IAdSpacePosition;
  height?: string;
  width?: string;
}

export interface Banner {
  id: number;
  name: string;
  details?: string;
  url: string;
  beginDate?: string;
  endDate?: string;
  imgData: string;
  adSpace?: AdSpace[];
  status: string;
}

interface BannerStorage {
  banners: Banner[];
}

const getBannersByPosition = (positionName: IAdSpacePosition): Banner[] => {
  try {
    const storage = localStorage.getItem('bannerStorage');

    if (!storage) return [];

    const data: BannerStorage = JSON.parse(storage);

    if (!data.banners || !Array.isArray(data.banners)) return [];

    return data.banners.filter(banner => {
      const space = banner.adSpace?.[0];

      if (!space) return false;

      const matches = space.positionName === positionName || space.adSpaceName === positionName;

      return banner.status === 'APPROVED' && matches;
    });
  } catch {
    return [];
  }
};

export { getBannersByPosition };
